<template>
    <!-- The iframe owns the presentation; a visible heading is optional rather than repeating "Product demo" over its canvas. -->
    <BaseDialog v-model:open="open" :title="resolvedDialogTitle" show-close layout="custom" dialog-content-class="p-4 md:max-w-5xl overflow-hidden rounded-xl">
        <BaseHeader v-if="headerText" usage="nadia" class="mb-4 pb-4 border-b border-border">{{ headerText }}</BaseHeader>
        <div class="relative pb-[56.25%] h-0">
            <iframe
                v-if="hasOpened"
                :src="demoUrl"
                :title="headerText ?? resolvedDialogTitle"
                loading="lazy"
                allow="clipboard-write"
                allowfullscreen
                class="absolute inset-0 w-full h-full border-0" />
        </div>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseDialog from "~vue/components/BaseDialog.vue";
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";

import BaseHeader from "./BaseHeader.vue";

const { t } = useI18n();
const resolvedDialogTitle = computed(() => dialogTitle ?? t("components.demoModal.title"));

interface Props {
    dialogTitle?: string;
    headerText?: string;
    demoUrl: string;
}

const { dialogTitle } = defineProps<Props>();

const open = defineModel<boolean>("open", { default: false });
const hasOpened = ref(false);

watch(open, (isOpen) => {
    if (isOpen && !hasOpened.value) {
        hasOpened.value = true;
    }
});
</script>
